import orderBy from "lodash/orderBy"
import { Media, MediaInput } from "./types"

// These constants and functions assume the GraphQL schema (currently) defined here:
// https://github.com/duointeractive/pathwright/blob/master/server/blocks/src/media/schema.js

export const prepMediaForSaving = (mediaItem: Media): MediaInput => {
  const {
    // Algolia fields to remove
    _highlightResult,
    __typename,
    objectID,
    __position,

    // Objects not suitable for mutations
    size,
    playback,
    thumb,
    encoding,

    // Legacy data fields
    contentType,

    // Snuck in
    lastUsedDateTime,

    // This is all we need
    ...validFields
  } = mediaItem

  return {
    ...validFields,
    tags: validFields.tags || []
  }
}

// prevMedia: Media
// updatedFields: MediaInput fields
// userID: string
// returns MediaInput
export const fieldsToMedia = (
  prevMedia: Media,
  updatedFields: Partial<Media>,
  userID?: string | number
) => {
  // Don't update createdByID if it's already set
  const createdByID = prevMedia.createdByID || userID || 100

  const media = {
    ...prevMedia,
    ...updatedFields,
    createdByID: Number(createdByID)
  }

  return prepMediaForSaving(media)
}

// mediaItems: [Media]
// returns [Media]
export const validateMedia = (mediaItems: Media[]) => {
  if (!mediaItems || !Array.isArray(mediaItems)) return []

  return mediaItems.filter((mediaItem) => {
    if (mediaItem.muxVideoID) return true

    if (!mediaItem.type || !mediaItem.url) {
      return false
    }

    return true
  })
}

// mediaItems: [Media]
// returns [Media]
// Use name as fallback sort param b/c multiple uploads can be simultaneous
export const sortMediaByDate = (mediaItems: Media[]) =>
  orderBy(mediaItems, ["createdDate", "name"], ["desc", "asc"])
